import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionStage } from '../components/SectionStage';
import { SectionLabel, SectionHeading } from '../components/ui/UI';
export function WherePeriscanFits() {
  return <>
      <PageHero eyebrow="Category Comparison" title="Where Periscan Fits" titleMuted="in Automated Security Validation." description="These companies helped validate the market. Periscan is focused on making continuous validation self-service, evidence-backed, open-source-accelerated, AI-era ready, and priced for continuous use." bg="none" data-id="element-1850" />

      <SectionStage fx="lightning" data-id="element-1851">
        <section className="relative w-full py-32 border-t border-white/5" data-id="element-1852">
          <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-1853">
            <SectionLabel number="01" label="The Landscape" className="mb-8" data-id="element-1854" />
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-1855">
              <div className="lg:col-span-8" data-id="element-1856">
                <SectionHeading size="xl" data-id="element-1857">
                  The category is real.
                  <br data-id="element-1858" />
                  <span className="text-white/40" data-id="element-1859">
                    The buying model is broken.
                  </span>
                </SectionHeading>
              </div>
            </div>
            <div className="mt-12 max-w-3xl text-lg text-white/60 leading-relaxed" data-id="element-1860">
              <p className="mb-6" data-id="element-1861">
                The market includes players like Picus, Pentera, Cymulate,
                Horizon3.ai / NodeZero, XM Cyber, SafeBreach, AttackIQ,
                CyCognito, Tenable, Qualys, Rapid7, and Wiz.
              </p>
              <p data-id="element-1862">
                These companies helped validate the market. Periscan is focused
                on making continuous validation self-service, evidence-backed,
                open-source-accelerated, AI-era ready, and priced for continuous
                use.
              </p>
            </div>
          </div>
        </section>
      </SectionStage>
    </>;
}